import qs from 'qs';

import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import parseCatch from 'utils/parseCatch';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

const URL = `${BASE_URL}/rest/v1.0/users/{username}/private-show-ratings`;
const UPDATE_URL = `${BASE_URL}/rest/v1.0/users/{username}/private-show-ratings/{ratingId}`;

/**
 * {@link https://cam4com.atlassian.net/wiki/spaces/RBN/pages/2171732393/Private+Show+Ratings+API documentation}
 */
class PrivateShowRatingService {
  /**
   * Send API call to get performers rating
   * @param  {String} broadcasterUsername performer name (broadcaster name)
   * @param  {String} voterUsername viewer name
   * @param  {String} accessHash Used to check integrity on backend
   * @param  {String} type 'PERFORMER/VIEWER'
   * @param  {String} login_user_nam viewer name
   * @return {(Promise | Array)} GET response data
   * if response is empty => do the POST
   * if response is not empty => do the PATCH
   * For now we don't show any success or error messages
   */
  getPerformerRating = (broadcasterUsername, viewerUsername, type, accessHash) => {
    const rawUrl = ApiService.substitute(URL, { username: broadcasterUsername });
    const encodedUrl = encodeURI(rawUrl);
    const params = {
      voterUsername: viewerUsername,
      ratingType: type,
      'login_user_name': viewerUsername,
      accessHash,
    };

    return ApiService.get(encodedUrl, { params })
      .then((res) => res.data)
      .catch((error) => parseCatch(error));
  };

  /**
   * Send API call to add performers rating
   * @param  {String} broadcasterUsername performer name (broadcaster name)
   * @param  {String} voterUsername viewer name
   * @param  {String} accessHash Used to check integrity on backend
   * @param  {String} type 'PERFORMER/VIEWER'
   * @param  {String} login_user_nam viewer name
   * @param  {Number} rating the amount of stars viewer rated the broadcaster [1-5] type INT
   * @return {(Promise | Array)} POST response data
   */
  addPerformerRating = (broadcasterUsername, viewerUsername, type, accessHash, rating) => {
    const rawUrl = ApiService.substitute(URL, { username: broadcasterUsername });
    const encodedUrl = encodeURI(rawUrl);
    const params = {
      'login_user_name': viewerUsername,
      accessHash,
    };
    const data = {
      voterUsername: viewerUsername,
      ratingType: type,
      rating,
    };

    return ApiService.post(encodedUrl, { params: qs.stringify(params), data })
      .then((res) => res.data)
      .catch((error) => parseCatch(error));
  };

  /**
   * Send API call to add performers rating if rating exists
   * @param  {String} broadcasterUsername performer name (broadcaster name)
   * @param  {String} voterUsername viewer name
   * @param  {String} accessHash Used to check integrity on backend
   * @param  {String} type 'PERFORMER/VIEWER'
   * @param  {String} login_user_nam viewer name
   * @param  {Number} rating the amount of stars viewer rated the broadcaster [1-5] type INT
   * @param  {Number} ratingId the ID got if from the GET method
   * @return {(Promise | Array)} PATCH response data
   */
  updatePerformerRating = (broadcasterUsername, viewerUsername, accessHash, ratingId, rating) => {
    const rawUrl = ApiService.substitute(UPDATE_URL, { username: broadcasterUsername, ratingId });
    const encodedUrl = encodeURI(rawUrl);
    const params = {
      'login_user_name': viewerUsername,
      accessHash,
    };
    const data = { rating };

    return ApiService.patch(encodedUrl, { params: qs.stringify(params), data })
      .then((res) => res.data)
      .catch((error) => parseCatch(error));
  };
}

export default new PrivateShowRatingService();
